import styled from 'styled-components';
import { inputBackgroundColor, primaryColor } from '@app/styles';

export const Dropzone = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  color: #172b4d;
  font-size: 0.85rem;
  justify-content: center;
  flex-direction: column;
`;
export const UploaderContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  background: ${inputBackgroundColor};
  overflow: hidden;
  border: 2px dashed #e3e5e9;
  &.dzu-dropzoneActive {
    border-color: ${primaryColor};
  }
  .dzu-inputLabelWithFiles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin: 0;
    background: ${inputBackgroundColor};
  }
`;
